import React from 'react'
import ReactDOM from 'react-dom'
import 'styles/main.scss'
import App from 'core/app'
import reportWebVitals from './reportWebVitals'
import "aos/dist/aos.css"
// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/effect-cube/effect-cube.min.css"
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";

import SwiperCore, {
  Mousewheel,
  Autoplay,
  Navigation,
  EffectCube,
  Pagination,
} from 'swiper'
SwiperCore.use([Mousewheel, Autoplay, Navigation, Pagination, EffectCube])

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('_mount')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
